module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsSAAALEgHS3X78AAABVUlEQVRYhe2XzU3EMBBG37faAnLjuh2QEtIBdEDoBDqggw2dpIQ9wolw4IDEIQUgDYe1F7OE/Ajbe9lPGsWyHfl5MhmPBVTOQvXAjt/qzWyo/1+6BmymtWZGTFu73Xp9AM/A5wDoJvbOAdZB+x24AN6Aysz64VfiahW0n4BH4BJoJRW5ATCz+hQQFfsA631gAI3r2wFF7MALLQSwo4EsEADFEEAuCL/QIEAOiEmA1BA+D9yPRamZ1ZIAboAWKJdE+ZjkA2HWZKlhn46bkwCk0Gp6yhngDLBMkjYnA5BUAy/umR8g0HYMQtKDpE5SleJ0q/muIes/5rRuvIruAZclb+d4AiiTfIIFEEWy33AC4nC3SJoHRiAOFfeaxDKzxh3lWwfxYzxLJjz2BEE9Ed0DrpT3C3Rm1nmIwBNXIV3sPHDHgrtmik/QAa9zJ2eviCSV7K8CAP0XDHHMNfxBCyQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/UI/Recurso 31.png
// module id = adOD
// module chunks = 1